import { Link } from "react-router-dom";
import ShieldIcon from "@assets/icon/shield.svg?react";
import { cn } from "@utils/tailwind-merge";
import { useTranslation } from "react-i18next";






export interface GoToInsurancePageProps {
  className?: string
}
export function GoToInsurancePage(props: GoToInsurancePageProps){

  const {t} = useTranslation();

  return (
    <Link
      to={"/insurance"} 
      className={cn(
        "bg-primary hover:bg-primary/90 text-white active:bg-primary/80 flex",
        "items-center gap-3 px-5 py-1.5 rounded-lg w-full text-nowrap", 
        props.className
      )}
    >
      <ShieldIcon className="w-5 h-5" />
      {/* Claim Your Insurance */}
      {t("widgets.main_navbar.claim_insurance")}
    </Link>
  )
}